module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5"
  }, [(_vm.info_url) ? _c('a', {
    attrs: {
      "href": _vm.info_url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/tavour-orange-black.svg")
    }
  })]) : _c('img', {
    attrs: {
      "src": require("../../assets/images/tavour-orange-black.svg")
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-md-2-5 text-right margin-25-top-sm margin-bottom-10"
  }, [_c('span', {
    staticClass: "question-text responsive"
  }, [_vm._v("Question? (206) 486-0669 "), _c('br'), _vm._v(" support@tavour.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa02001e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/PageHeader.vue
// module id = 419
// module chunks = 1